import * as yup from 'yup'
import { emailValidationSchema } from './singleFieldsValidationSchemas'

const validationSchema = yup.object({
  email: emailValidationSchema,
})

export default validationSchema
